// projects/humanresources-personnel/src/assets/i18n/*/hr-per-object-definition.json
export class HrPerObjectDefinitionKey {
    private static readonly keyPrefix = 'hrPerObjectDef';
    public static title = `${HrPerObjectDefinitionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerObjectDefinitionKey.keyPrefix}.pageHeader`;
    public static object = `${HrPerObjectDefinitionKey.keyPrefix}.object`;
    public static objectNumber = `${HrPerObjectDefinitionKey.keyPrefix}.objectNumber`;
    public static objectCode = `${HrPerObjectDefinitionKey.keyPrefix}.objectCode`;
}
